/* istanbul ignore file */
import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconContentFace({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id='content-face_svg__a'>
            <path d='M1.395.707H23.98v22.586H1.395Zm0 0' />
          </clipPath>
        </defs>
        <g clipPath='url(#content-face_svg__a)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.3242308799999998}
            d='M12.688 22.59c5.847 0 10.59-4.742 10.59-10.59S18.534 1.41 12.687 1.41C6.84 1.41 2.102 6.152 2.102 12S6.84 22.59 12.688 22.59m0 0'
          />
        </g>
        <path
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.3242308799999998}
          d='M19.04 13.41a6.358 6.358 0 0 1-6.352 6.355 6.36 6.36 0 0 1-6.352-6.355M18.8 8.469a2.1 2.1 0 0 1-.777 1.023 2.1 2.1 0 0 1-1.222.39 2.12 2.12 0 0 1-1.996-1.413M10.57 8.469a2.08 2.08 0 0 1-.773 1.023 2.11 2.11 0 0 1-2.445 0 2.08 2.08 0 0 1-.774-1.023'
        />
      </svg>
    </>
  )
}
IconContentFace.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconContentFace
